import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsCsharpComponent } from './simple-icons-csharp.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsCsharpComponent ],
    exports:      [ SimpleIconsCsharpComponent ],
    bootstrap:    []
})
export class SimpleIconsCsharpModule {}
